












import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';

interface Data {}

interface Methods {}

interface Computed {}

interface Props {
  description: string;
}

export default Vue.extend({
  name: 'NoDealsStub',
  props: {
    description: {
      type: String,
      default: () => '',
    },
    preposal: {
      type: String,
      default: () => '',
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
